export const GET_GUESTS = "GET_GUESTS";
export const GET_GUESTS_SUCCESS = "GET_GUESTS_SUCCESS";
export const GET_GUESTS_FAIL = "GET_GUESTS_FAIL";


